import AddCircleIcon from '@mui/icons-material/AddCircle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion,AccordionSummary,Button,Divider,FormControl,IconButton,InputLabel,MenuItem,Select,Stack,Tooltip,Typography } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import React,{ useContext,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AiFillCopy,AiFillDelete,AiFillTool } from 'react-icons/ai';
import { BsShieldFillCheck } from 'react-icons/bs';
import { FaListAlt,FaNetworkWired } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { UserContext } from '../../context/UserContext';
import AttToken from '../../helpers/attToken';
import { trackEventMatomo } from '../../helpers/matomo';
import { ConjuntoType,UnidadeType } from '../../service/Places';
import queryClient from '../../service/query';
import Set from '../../service/Set';
import Unity from '../../service/Unity';
import EditAproveModal from './Modal/Aprovadores/EditAproveModal';
import SetTypeAssoci from './Modal/Associacoes/SetTypeAssoci';
import EditModal from './Modal/EditModal';
import NewModal from './Modal/NewModal';
import ModalPA from './Modal/PlanoDeAcao/ModalPA';
import RemoveModal from './Modal/RemoveModal';
import { reorderType } from './PlacesComponent';
import UnityComponent from './UnityComponent';

const setService = new Set();

type setAcordeonType = {
  set: ConjuntoType,
  placeId: string,
  selected: string[]
  conjuntosList: ConjuntoType[]
  index: number,
  expandedConjs: boolean[],
  setExpandedConjs: Function,
  local: reorderType,
  setLocal: Function
};

const UnityService = new Unity();
const SetService = new Set();

export default function SetAcordeon({
  set,
  placeId,
  selected,
  index,
  expandedConjs,
  setExpandedConjs,
  local,
  setLocal,
}:
  setAcordeonType
) {
  const [modalOpen, setModalOpen] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openRemove, setOpenRemove] = useState(false);
  const { hierarchyLabel, customerId, acessoPlanoDeAcao } = useContext(UserContext);
  const [associationModal, setAssociationModal] = useState(false);
  const [openModalAprove, setOpenModalAprove] = useState(false);
  const [reorderBy, setReorderBy] = useState<string>(local[set.id] ?? 'crescent');

  const [openModalPA, setOpenModalPA] = useState<boolean>(false);


  const { t } = useTranslation('translation');

  const { mutate: remove, isPending: removendoConjunto } = useMutation({
    mutationKey: ['REMOVE_SET'],
    mutationFn: async () => {
      const token = await AttToken();
      if (!token) throw new Error('Token not found');
      const promise = setService.deleteConjunto(token, set.id, placeId)
        .then(() => true);
      return toast.promise(
        promise,
        {
          pending: `${t('notifications.deleteNotifWait')}`,
          error: `${t('Services.servicesManagement.errorRemoving')}`,
          success: `${hierarchyLabel.conjunto} ${t('deleted')}!`
        }, { toastId: 'removendo conjunto' });
    },
    onSuccess: () => {
      setOpenRemove(false);
      queryClient.refetchQueries({ queryKey: ['GET_PLACES'] });
    },
  });

  const { mutate: edit, isPending: editandoConjunto } = useMutation({
    mutationKey: ['EDIT_SET'],
    mutationFn: async (name: string) => {
      const response = toast.promise(async () => {
        trackEventMatomo('tela locais', 'click', 'button', 'edita unidade');
        const token = await AttToken();
        if (token) {
          const res = await SetService.changeConjunto(token, set.id, name);
          if (!res) throw new Error('Erro ao editar');
          return res;
        }
      }, {
        success: `${hierarchyLabel.conjunto} ${t('edited')}!`,
        error: t('places.erroSalvar'),
        pending: t('places.salvando')
      }, { toastId: 'editandoConjunto' });
      return response;
    },
    onSuccess: () => {
      setOpenEditModal(false);
      queryClient.refetchQueries({ queryKey: ['GET_PLACES'] });
    }
  });

  const { mutate: create, isPending: criandoConjunto } = useMutation({
    mutationKey: ['CREATE_SET'],
    mutationFn: async (name: string) => {
      const response = toast.promise(async () => {
        trackEventMatomo('tela locais', 'click', 'button', 'cria unidade');
        const token = await AttToken();
        const UnityObj = {
          cliente: customerId,
          conjunto: set.id,
          dataAlteracao: Date.now(),
          local: placeId,
          nome: name
        };
        if (token) {
          const response = await UnityService.newUnity(token, UnityObj);
          if (!response) throw new Error('Erro ao criar');
          return response;
        }
      }, {
        success: `${hierarchyLabel.unidade} ${t('created')}!`,
        error: t('places.erroSalvar'),
        pending: t('places.salvando')
      }, { toastId: 'criaConjunto' });
      return response;
    },
    onSuccess: () => {
      setModalOpen(false);
      queryClient.refetchQueries({ queryKey: ['GET_PLACES'] });
    }
  });

  const { mutate: clone, isPending: clonandoConjunto } = useMutation({
    mutationKey: ['CLONE_SET'],
    mutationFn: async (setid: string) => {
      const response = toast.promise(async () => {
        trackEventMatomo('tela locais', 'click', 'button', 'clona unidade');
        const token = await AttToken();
        if (token) {
          const response = await setService.duplicateConjunto(token, setid);
          if (!response) throw new Error('Erro ao clonar');
          return response;
        }
      }, {
        success: `${t('Services.servicesManagement.duplicatedLocation')}`,
        error: t('places.erroSalvar'),
        pending: t('places.salvando')
      }, { toastId: 'clonaConjunto' });
      return response;
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['GET_PLACES'] });
    }
  });

  const switchSort = (value: string, a: UnidadeType, b: UnidadeType) => {
    switch (value) {
      case 'crescent':
        return (a.nome?.toLowerCase() > b.nome?.toLowerCase());
      case 'decrescent':
        return (a.nome?.toLowerCase() < b.nome?.toLowerCase());
      default: return (a.nome?.toLowerCase() > b.nome?.toLowerCase());
    }
  };

  const onLoading = clonandoConjunto || criandoConjunto || editandoConjunto || removendoConjunto;

  const nameOf = 'conjunto';
  const nameCreate = 'unidade';
  const nameRemove = 'conjunto';

  return (
    <>
      {openModalAprove && <EditAproveModal
        conjunto={set}
        openModalAprove={openModalAprove}
        setOpenModalAprove={setOpenModalAprove}
      />}
      {modalOpen && <NewModal
        isDisabled={onLoading}
        nameCreate={nameCreate}
        create={create}
        setModalOpen={setModalOpen}
        modalOpen={modalOpen}
      />}
      {openEditModal
        && <EditModal
          isDisabled={onLoading}
          edit={edit}
          open={openEditModal}
          setOpen={setOpenEditModal}
          componentName={set.nome}
          nameOf={nameOf}
        />}
      {openModalPA && <ModalPA
        openModalPA={openModalPA}
        setOpenModalPA={setOpenModalPA}
        conjunto={set}
      />}
      {associationModal && <SetTypeAssoci
        set={set}
        open={associationModal}
        setOpen={setAssociationModal}
      />}
      {openRemove && <RemoveModal
        mutate={remove}
        openRemove={openRemove}
        setOpenRemove={setOpenRemove}
        nameRemove={nameRemove}
      />}
      <Accordion expanded={expandedConjs[index]}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon
            onClick={() => {
              trackEventMatomo('tela serviços', 'click', 'acordeon', 'abre/fecha');
              expandedConjs?.forEach((e, i) => {
                if (index === i) {
                  expandedConjs[i] = !expandedConjs[index];
                } else { expandedConjs[i] = false; }
              });
              setExpandedConjs([...expandedConjs]);
            }}
          />}
          style={{ backgroundColor: '#f3f3f4' }}
        >
          <Stack direction='row' width='100%' justifyContent='space-between' alignItems='flex-start' padding={1}>
            <Typography color='success' variant='h6' fontWeight={600}>
              {set.nome}
            </Typography>
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={1}
            >
              <Tooltip title={`${t('teamManage.register.kindOfService')}`}>
                <span>
                  <IconButton
                    disabled={onLoading}
                    onClick={() => {
                      trackEventMatomo('tela serviços', 'click', 'button', 'abre modal');
                      setAssociationModal(true);
                    }}
                    aria-label="service">
                    <FaNetworkWired size={25} />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title={`${t('edit')} ${t('approver')}`}>
                <span>
                  <IconButton
                    disabled={onLoading}
                    onClick={() => {
                      trackEventMatomo('tela serviços', 'click', 'button', 'abre modal');
                      setOpenModalAprove(true);
                    }}
                    aria-label="aproover" color='secondary'>
                    <BsShieldFillCheck />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title={`${t('edit')} ${hierarchyLabel.conjunto ?? 'Conjunto'}`}>
                <span>
                  <IconButton
                    onClick={() => {
                      trackEventMatomo('tela serviços', 'click', 'button', 'abre modal');
                      setOpenEditModal(true);
                    }}
                    aria-label="edit" color='info'>
                    <AiFillTool size={25} />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title={t('Services.servicesManagement.actionPlanAssociations')}>
                <span>
                  <IconButton
                    onClick={() => {
                      trackEventMatomo('tela serviços', 'click', 'button', 'abre modal');
                      setOpenModalPA(!openModalPA);
                    }}
                    disabled={!acessoPlanoDeAcao || onLoading} aria-label="PA" color='warning'>
                    <FaListAlt />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title={`${t('checklists.checklists.clone')} ${hierarchyLabel.conjunto}`}>
                <span>
                  <IconButton
                    disabled={onLoading}
                    onClick={() => clone(set.id)}
                    aria-label="clone" color='success'>
                    <AiFillCopy size={25} />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title={`${t('delete')} ${hierarchyLabel.conjunto ?? 'Conjunto'}`}>
                <span>
                  <IconButton
                    disabled={onLoading}
                    onClick={() => {
                      trackEventMatomo('tela serviços', 'click', 'button', 'exclui conjunto');
                      setOpenRemove(true);
                    }}
                    aria-label="delete" color='error'>
                    <AiFillDelete size={25} />
                  </IconButton>
                </span>
              </Tooltip>
            </Stack>
          </Stack>
        </AccordionSummary>
        <Stack direction='column' spacing={2} alignItems='flex-start' justifyContent='flex-start' padding={2}>
          <Button
            variant='contained'
            color='success'
            endIcon={<AddCircleIcon />}
            onClick={() => {
              trackEventMatomo('tela serviços', 'click', 'button', 'abre modal');
              setModalOpen(true);
            }}
          >
            {`${t('add')} ${hierarchyLabel.unidade ?? 'Unidade'}`}
          </Button>
          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <FormControl sx={{ width: '300px' }}>
              <InputLabel>{t('Services.servicesManagement.sortBy')}</InputLabel>
              <Select
                value={reorderBy ?? ''}
                label={t('Services.servicesManagement.sortBy')}
                onChange={(event) => {
                  setReorderBy(event.target.value);
                  local[set.id] = event.target.value;
                  setLocal(local);
                  localStorage.setItem('localOrder', JSON.stringify(local));
                }}
              >
                <MenuItem value={'crescent'}>{t('Services.servicesManagement.alphabeticalAscending')} (A-Z)</MenuItem>
                <MenuItem value={'decrescent'}>{t('Services.servicesManagement.alphabeticalDescending')} (Z-A)</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </Stack>
        {expandedConjs[index]
          && set.unidadesList.length ? set?.unidadesList
            ?.sort((unidadeA, unidadeB) => {
              return switchSort(reorderBy, unidadeA, unidadeB) ? 1 : - 1;
            })?.map((e, i) => (
              expandedConjs
              && <React.Fragment key={i}>
                <UnityComponent
                  unity={e}
                  selected={selected}
                  set={set.id}
                />
                <Divider />
              </React.Fragment>
            )) : <Typography padding={2} textAlign='center' color='textDisabled' fontWeight={600}>{
              `${t('places.este')} ${hierarchyLabel.conjunto} ${t('places.aindaNaoTem')} ${hierarchyLabel.unidade ?? 'Unidade'} ${t('places.adicionado')}`}
        </Typography>}
      </Accordion >
    </>
  );
}
